import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import { legShape } from 'constants/propTypes';

import useTimetableServicesQuery from 'components/queries/useTimetableServicesQuery';

import { hasActiveAOP } from './utils';

import FallbackMessage from './FallbackMessage';
import TrainSwapWarning from './TrainSwapWarning';
import StopsSummary from './StopsSummary';

const TimetableServiceStopsStatusSummary = ({ journey, popupId, setServiceStatusMismatch }) => {
  const [isLimitedService, setIsLimitedService] = useState(false);
  const {
    timing: { date },
    serviceType: { code: carrier },
    trainNumber
  } = journey;

  if (setServiceStatusMismatch) {
    const activeAOP = hasActiveAOP(journey.products);
    setServiceStatusMismatch(!activeAOP && isLimitedService);
  }

  const destinationUic = journey.destination?.uic;
  const originUic = journey.origin?.uic;

  const { timetableServices, loading } = useTimetableServicesQuery({ carrier, date, destinationUic, originUic, trainNumber });

  if (loading) {
    return null;
  }

  if (!timetableServices || !destinationUic || !originUic) {
    return (
      <ReactTooltip className="tooltip" id={popupId} data-testid={popupId} place="bottom">
        <FallbackMessage />
      </ReactTooltip>
    );
  }

  return (
    <ReactTooltip className="tooltip" id={popupId} data-testid={popupId} place="bottom">
      <TrainSwapWarning timetableServices={timetableServices} />
      <StopsSummary
        timetableServices={timetableServices}
        setIsLimitedService={setIsLimitedService}
        originUic={originUic}
        destinationUic={destinationUic}
        dark
      />
    </ReactTooltip>
  );
};

TimetableServiceStopsStatusSummary.propTypes = {
  journey: legShape.isRequired,
  popupId: PropTypes.string.isRequired,
  setServiceStatusMismatch: PropTypes.func
};

export default TimetableServiceStopsStatusSummary;
